import {Component, ComponentFactoryResolver, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild, ViewContainerRef} from '@angular/core';
import {TabComponent} from '../tab/tab.component';
import {PlayerListComponent} from '../../../../site/components/player-list/player-list.component';
import {SubscriptionEditComponent} from '../../../../site/components/subscription-edit/subscription-edit.component';
import {MiscellaneousEditComponent} from '../../../../site/components/miscellaneous-edit/miscellaneous-edit.component';
import {NetworkEditComponent} from '../../../../site/components/network-edit/network-edit.component';
import * as _ from 'lodash';
import {DataTabs} from '../../../models/tabs-data';
import {Store} from '@ngrx/store';
import * as fromSites from '../../../../site/reducers';
import {PatchSitesAction} from '../../../../site/actions/subscription-site-update';
import {Router} from '@angular/router';
import {AddressesEditComponent} from '../../../../site/components/addresses-edit/addresses-edit.component';
import {ContactEditComponent} from '../../../../site/components/contact-edit/contact-edit.component';
import {PlayerConfigurationEditComponent} from '../../player-configuration-edit/player-configuration-edit.component';
import {ContainerShippingsComponent} from '../../../../site/components/container-shippings/container-shippings.component';
import {CompanyDisplayComponent} from '../../../../company/components/company-display/company-display.component';
import {ContractsListComponent} from '../../../../contract/pages/list/contracts-list.component';
import {ContractEditComponent} from '../../../../contract/components/contract-edit/contract-edit.component';
import { PublicationListComponent } from '../../../../site/components/publication-list/publication-list.component';
import {OrderDetailComponent} from '../../../../order/pages/details/order-detail.component';
import {ShippingDetailComponent} from '../../../../shipping/page/detail/shipping-detail.component';
import {InvoicesListComponent} from '../../invoices-list/invoices-list.component';
import {SubscriptionListComponent} from '../../subscription-list/subscription-list.component';
import {SitesListComponent} from '../../../../site/pages/list/sites-list.component';
import {DashboardOrdersComponent} from '../../../../dashboard/pages/dashboard-orders/dashboard-orders.component';
import {DashboardSalesComponent} from '../../../../dashboard/pages/dashboard-sales/dashboard-sales.component';
import {CompaniesListComponent} from '../../../../company/pages/list/companies-list.component';
import {ProjectListComponent} from '../../../../site/components/project-list/project-list.component';
import {SiteEditComponent} from '../../../../site/components/site-edit/site-edit.component';
import {PatchSitesMultiAction} from '../../../../site/actions/multi-subscription-site-update';
import {SubscriptionMultiEditComponent} from '../../../../site/components/subscription-edit-multi/subscription-edit.component';
import {ContractLanguageTextComponent} from '../../../../contract/components/contract-language-text/contract-language-text.component';
import {SubscriptionListSimpleComponent} from '../../subscription-list/subscription-list-simple.component';
import {UpdateContractCommentAction} from '../../../../contract/actions/contract-add';

const components = {
  datatablePlayerList: PlayerListComponent,
  subscriptionEditable: SubscriptionEditComponent,
  subscriptionMultiEditable: SubscriptionMultiEditComponent,
  siteEditable: SiteEditComponent,
  addressesEditable: AddressesEditComponent,
  contactsEditable: ContactEditComponent,
  miscellaneousEditable: MiscellaneousEditComponent,
  networkEditable: NetworkEditComponent,
  playerConfigurationEditable: PlayerConfigurationEditComponent,
  containerShipping: ContainerShippingsComponent,
  datatableContracts: ContractsListComponent,
  companyDisplay: CompanyDisplayComponent,
  contractEditable: ContractEditComponent,
  subscriptionsList: SubscriptionListComponent,
  subscriptionsListSimple: SubscriptionListSimpleComponent,
  companiesList: CompaniesListComponent,
  datatablePublicationList: PublicationListComponent,
  orderEditable: OrderDetailComponent,
  shippingEditable: ShippingDetailComponent,
  invoicesList: InvoicesListComponent,
  sitesList: SitesListComponent,
  SalesDashboard: DashboardSalesComponent,
  OrdersDashboard: DashboardOrdersComponent,
  projectsList: ProjectListComponent,
  contractLanguageText: ContractLanguageTextComponent,
};

@Component({
  selector: 'storever-edit-tabs',
  templateUrl: './edit-tabs.component.html',
  styleUrls: ['./edit-tabs.component.scss']
})
export class EditTabsComponent implements OnChanges, OnDestroy {
  componentRef;
  @Input() tabDisplay: TabComponent;
  @Input() data: DataTabs;

 // @ViewChild('componentContainer', { read: ViewContainerRef }) container;
  @ViewChild('componentContainer',  {static: true ,  read: ViewContainerRef}) container;

  constructor(private resolver: ComponentFactoryResolver,
              private store: Store<fromSites.AppState>,
              private router: Router) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (_.has(changes, 'tabDisplay')) {
      const change = _.get(changes, 'tabDisplay');
      this.createComponent(change.currentValue);
    }
  }

  createComponent(content: TabComponent): void {
    const component = components[content.content];
    this.container.clear();
    if (this.componentRef) {
      if (this.componentRef.instance.sub$) {
        this.componentRef.instance.sub$.unsubscribe();
      }
      this.componentRef.destroy();
    }

    const factory = this.resolver.resolveComponentFactory<PlayerListComponent
      | SubscriptionEditComponent
      | SubscriptionMultiEditComponent
      | AddressesEditComponent
      | ContactEditComponent
      | MiscellaneousEditComponent
      | NetworkEditComponent
      | PlayerConfigurationEditComponent
      | ContainerShippingsComponent
      | ContractEditComponent
      | ContractsListComponent
      | CompanyDisplayComponent
      | ContractLanguageTextComponent
      | SubscriptionListComponent
      | SubscriptionListSimpleComponent
      | CompaniesListComponent
      | PublicationListComponent
      | ShippingDetailComponent
      | OrderDetailComponent
      | InvoicesListComponent
      | SitesListComponent
      | DashboardSalesComponent
      | DashboardOrdersComponent
      | SiteEditComponent
      >(component);
    this.componentRef = this.container.createComponent(factory);
    const dataTab = _.find(this.data.dataTabs, { 'contentTab': content.content });
    this.componentRef.instance.dataConfig = dataTab.dataConfig;
    this.componentRef.instance.titleFragment = content.title;

    const instance = this.componentRef.instance;
    // activate the tab the user has clicked on and update url fragment
    this.router.navigate([], { fragment: content.title });
    this.save(instance);
  }

  // tslint:disable-next-line:no-any
  save(instance: any): void {
    if (instance.saveForm) {
      instance.saveForm.subscribe(data => {
        if (data.type && data.type === 'multiSubscription') {
          this.store.dispatch(new PatchSitesMultiAction(data)); // TODO: should be abstract
        }
        else if (data.type && data.type === 'contracts') {
          this.store.dispatch(new UpdateContractCommentAction(data)); // TODO: should be abstract
        }
        else {
          this.store.dispatch(new PatchSitesAction(data)); // TODO: should be abstract
        }

        instance.dataConfig.form.disable();
        instance.dataConfig.form.markAsPristine();
      });
    }
    // TODO: need to unsubscribe ?

  }
  ngOnDestroy(): void {
    // this.container.clear();
    // if (this.componentRef) {
    //   if (this.componentRef.instance.sub$) {
    //     this.componentRef.instance.sub$.unsubscribe();
    //   }
    //   this.componentRef.destroy();
    // }
  }
}
